import config from '../config.js';
import AthomCloudAPI from 'homey-api/lib/AthomCloudAPI';

export const cloudApi = new AthomCloudAPI({
    clientId: config.athomApiClientId,
    clientSecret: config.athomApiClientSecret,
    redirectUrl: window.location.origin,
});

// Reference: https://athombv.github.io/node-homey-api/AthomCloudAPI.html
export const initializeCloudApi = async () => {
    try {
        const loggedIn = await cloudApi.isLoggedIn();

        if (!loggedIn) {
            if (cloudApi.hasAuthorizationCode()) {
                await cloudApi.authenticateWithAuthorizationCode();
            } else {
                window.location.href = cloudApi.getLoginUrl();
                return;
            }
        }

        const user = await cloudApi.getAuthenticatedUser();
        return user;
    } catch (error) {
        console.error('Error:', error.message);
        throw error;
    }
};

export const logoutCloudApi = async () => {
    try {
        await cloudApi.logout();
    } catch (error) {
        console.error('Logout error:', error.message);
        throw error;
    }
};

export const requestAccess = async (homey) => {
    if (!homey) {
        throw new Error('Missing Homey');
    }

    const jwt = await cloudApi.createDelegationToken({ audience: 'installer' });
    const response = await fetch(`${homey.remoteUrl}/api/manager/users/installer/request`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ jwt }),
    });

    if (!response.ok) {
        const body = await response.json().catch(() => ({}));
        throw new Error(body.error || `Request failed (${response.status})`);
    }
};